import useUrlParams from '../../hooks/useUrlParams';
import { useDispatch, useSelector } from 'react-redux';
import React, { Suspense, useCallback, useEffect } from 'react';
import { getInvoices } from '../../store/actions/tenantsAction';
import AGGridHeader from '../AGGrid/AGGridHeader';
import Spinner from '../../components/Spinner/Spinner';
import Grow from '@mui/material/Grow';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import AGGridTable from '../AGGrid';
import Container from '../../components/Container/Container';
import useStyles from '../../styles/tables';
import Button from '@mui/material/Button';
import { formatInvoiceDate, formatNumberToCurrency, formatPeriod } from '../../helpers/utils';
import { format, parse } from 'date-fns';
import Icon from '@mui/material/Icon';
import { openModal } from '../../components/Modal/modalReducer';
import StatusRenderer from './InvoiceStatusRenderer';

const Invoice = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { portfolioIds, assetIds } = useUrlParams();
  const { loaded, error, data: invoices } = useSelector((state) => state.tenants.invoices);

  const COLS = [
    {
      colId: 'name',
      headerName: 'Tenant',
      field: 'companyname',
      filter: 'agSetColumnFilter',
      chartDataType: 'category',
      enableRowGroup: true,
      headerComponent: AGGridHeader
    },
    {
      colId: 'assetName',
      headerName: 'Asset',
      field: 'assetname',
      filter: 'agSetColumnFilter',
      chartDataType: 'category',
      enableRowGroup: true,
      headerComponent: AGGridHeader
    },
    {
      colId: 'tradingName',
      headerName: 'Tenant Contract Ref',
      field: 'tradingname',
      filter: 'agSetColumnFilter',
      chartDataType: 'category',
      enableRowGroup: true,
      headerComponent: AGGridHeader
    },
    {
      headerName: 'Portfolio',
      field: 'portfolioname',
      enableRowGroup: true,
      headerComponent: AGGridHeader
    },
    {
      headerName: 'Main Contact',
      field: 'maincontact',
      enableRowGroup: true,
      headerComponent: AGGridHeader
    },
    {
      headerName: 'Invoice Date',
      field: 'nextinvoicedate',
      chartDataType: 'category',
      cellRenderer: (params) =>
        formatInvoiceDate(params.data.nextinvoicedate),
      headerComponent: AGGridHeader
    },
    {
      headerName: 'Period',
      field: 'nextinvoiceperiodstartdate',
      filter: 'agDateColumnFilter',
      chartDataType: 'category',
      valueGetter: params =>
        formatPeriod(params.data.nextinvoiceperiodstartdate, params.data.nextinvoiceperiodenddate),
      minWidth: 230,
      headerComponent: AGGridHeader
    },
    {
      headerName: 'Payment Value',
      field: 'nextinvoicepaymentvalue',
      filter: 'agNumberColumnFilter',
      chartDataType: 'category',
      cellRenderer: (params) => formatNumberToCurrency(params.value),
      headerComponent: AGGridHeader
    },
    {
      headerName: 'Status',
      field: 'nextinvoicestatus',
      filter: 'agSetColumnFilter',
      chartDataType: 'category',
      headerComponent: AGGridHeader,
      cellRenderer: StatusRenderer
    },
    {
      colId: 'actions',
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: (params) => {
        const handleManage = () => {
          dispatch(
            openModal({
              modalType: 'InvoiceManageModal',
              modalProps: {
                tenant: params.data
              }
            })
          );
        };

        return (
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button variant="outlined" size="small" onClick={handleManage}>
              Manage
            </Button>
          </div>
        );
      },
      minWidth: 150,
      filter: false,
      sortable: false,
      resizable: false,
      headerComponent: AGGridHeader,
      suppressMenu: true,
      cellStyle: { display: 'flex', alignItems: 'center' }
    }
  ];

  useEffect(() => {
    dispatch(getInvoices());
  }, [portfolioIds, assetIds]);

  const editSettings = () => {
    dispatch(openModal({
      modalType: 'InvoiceSettingsModal'
    }))
  };

  return (
    <Container>
      <Suspense fallback={<Spinner mini />}>
        <Grow in>
          <Box className={clsx(classes.containerLarge)}>
            <Box className={classes.header}>
              <Typography className={classes.title}>{`Invoices (${
                invoices?.length || 0
              })`}</Typography>

              <Button startIcon={<Icon>settings</Icon>} onClick={editSettings}>
                Settings
              </Button>
            </Box>

            <AGGridTable
              data={loaded && invoices}
              colDefs={COLS}
              classes={classes}
              rowGroupPanelShow={'always'}
              groupDisplayType={'multipleColumns'}
            ></AGGridTable>
          </Box>
        </Grow>
      </Suspense>
    </Container>
  );
};

export default Invoice;
